var map = {
	"./accident_back.svg": "d711",
	"./accident_crash.svg": "26ec",
	"./accident_turn_over.svg": "579a",
	"./airlink.svg": "05b7",
	"./bts.svg": "ffda",
	"./bus.svg": "c2d2",
	"./death.svg": "2b2d",
	"./dizzy_bar.svg": "5117",
	"./government_doh.svg": "6868",
	"./government_drr.svg": "c88e",
	"./government_motorway.svg": "7485",
	"./ic_accident_bl.svg": "c527",
	"./ic_analytic.svg": "56c5",
	"./ic_analytic_wh.svg": "f411",
	"./ic_area.svg": "edce",
	"./ic_area_wh.svg": "3070",
	"./ic_die_bl.svg": "8e62",
	"./ic_injury_bl.svg": "eac9",
	"./ic_klong.svg": "059c",
	"./ic_layers.svg": "3619",
	"./ic_many_point.svg": "a47b",
	"./ic_many_point_wh.svg": "de13",
	"./ic_point.svg": "944c",
	"./ic_point_wh.svg": "3489",
	"./ic_river.svg": "89b3",
	"./ic_sea.svg": "bf84",
	"./local_road.svg": "b45e",
	"./other_appearance.svg": "e26c",
	"./other_location.svg": "00cf",
	"./other_reason.svg": "09c1",
	"./plane_ac.svg": "4186",
	"./plane_hard_ac.svg": "c201",
	"./road_ cross.svg": "d5a9",
	"./road_curve.svg": "d62c",
	"./road_straight.svg": "50bc",
	"./trailer.svg": "a8ad",
	"./train.svg": "d280",
	"./train_accident.svg": "2848",
	"./truck.svg": "e5ca",
	"./user-injured-solid.svg": "1cb8",
	"./user_injured_bar.svg": "7246",
	"./way_road.svg": "ece0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";